import * as Views from "./views";


const Module = {
    name: "biviewer",
    defaultRoutePath: "/bis/biviewer",
    menuItemScope: "bis",
    menuItemName: "viewer",

    routes: [
        {
            path: "/bis/biviewer",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
    ]
}



export default Module;
